module.exports = __webpack_public_path__ + "static/media/reusability.32d1c163.svg";